import axios from 'axios';

export const deleteDraftConnector = async (id) => {
  const result = await axios.delete(`/api/v1/dom/draft/${id}`);

  return result;
};
